import { render, staticRenderFns } from "./Pavilion.vue?vue&type=template&id=09c895ec&scoped=true&"
import script from "./Pavilion.vue?vue&type=script&lang=js&"
export * from "./Pavilion.vue?vue&type=script&lang=js&"
import style0 from "./Pavilion.vue?vue&type=style&index=0&id=09c895ec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c895ec",
  null
  
)

export default component.exports